import { render, staticRenderFns } from "./WsSortDialog.vue?vue&type=template&id=348b7374&"
import script from "./WsSortDialog.vue?vue&type=script&lang=js&"
export * from "./WsSortDialog.vue?vue&type=script&lang=js&"
import style0 from "./WsSortDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
